import { FormlyFormOptions, FormlyFieldConfig } from '@ngx-formly/core';

export class FormlyDialog {
  titel = '';
  model: any = {};
  fields: FormlyFieldConfig[];
  options: FormlyFormOptions = {};
}
